<template>
  <div class="fireArea-container">
    <BubbleMenu :ref="'EditorMenuBubble'" class="menububble-component" :editor="editor">
      <div class="menububble">
        <button
          class="menububble__button button ml"
          :class="{ active: editor.isActive('bulletList') }"
          @click="editor.chain().focus().toggleBulletList().run()"
        >
          <i class="material-icons icon">format_list_bulleted</i>
        </button>

        <button
          class="menububble__button button line-right"
          :class="{ active: editor.isActive({ textAlign: 'justify' }) }"
          @click="
            editor.isActive({ textAlign: 'justify' })
              ? editor.chain().focus().setTextAlign('left').run()
              : editor.chain().focus().setTextAlign('justify').run()
          "
        >
          <i class="material-icons icon">format_align_justify</i>
        </button>
        <button
          class="menububble__button button"
          :class="{ active: editor.isActive('bold') }"
          @click="editor.chain().focus().toggleBold().run()"
        >
          <b>B</b>
        </button>
        <button
          class="menububble__button button"
          :class="{ active: editor.isActive('italic') }"
          @click="editor.chain().focus().toggleItalic().run()"
        >
          <i>i</i>
        </button>
        <button
          class="menububble__button button"
          :class="{ active: editor.isActive('underline') }"
          @click="editor.chain().focus().toggleUnderline().run()"
        >
          <u>U</u>
        </button>
      </div>
    </BubbleMenu>

    <EditorContent
      :ref="templateDivContainer"
      class="text-area editor__content"
      :class="{ smallHeight: smallHeight }"
      :editor="editor"
    />
  </div>
</template>

<script>
import FireInput from './FireInput';
import { Editor, EditorContent } from '@tiptap/vue-3';
import { BubbleMenu } from '@tiptap/vue-3/menus';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import StarterKit from '@tiptap/starter-kit';

export default {
  name: 'FireArea',
  components: {
    EditorContent,
    BubbleMenu,
  },
  mixins: [FireInput],
  props: {
    templateDivContainer: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 0,
    },
    smallHeight: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor: null,
      updating: false,
    };
  },
  watch: {
    input(text) {
      if (!this.updating && text !== undefined) {
        this.editor.commands.setContent(text.toString());
      }
      this.updating = false;
    },
  },
  created() {
    this.editor = new Editor({
      extensions: [
        StarterKit,
        Underline,
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
      ],
      autoFocus: this.autoFocus,
      content: this.input,
      editable: !this.disabled,
      onUpdate: ({ editor }) => {
        this.updating = true;
        this.input = editor.getHTML() === '<p></p>' ? '' : editor.getHTML();
      },
    });
  },
  beforeUnmount() {
    this.editor.destroy();
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/inspector.scss';

.menububble-component {
  border: none !important;
  min-height: auto !important;
  padding: 0;
  z-index: 1;

  .menububble {
    padding: 5px;
    display: flex;
    z-index: 20;
    background: rgb(32, 29, 29);
    border-radius: 5px;
    transition:
      opacity 0.2s,
      visibility 0.2s;

    &__button {
      border-radius: 5px;
      margin: 0 2px;
      background: transparent;
      border: 0;
      padding: 0 0.5rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      position: relative;
      justify-content: center;
      width: 32px;
      height: 32px;
      color: #808080;
      box-sizing: border-box;
      font-size: 12px;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        background-color: rgba(#fff, 0.1);
      }

      &.active {
        background-color: rgba(#fff, 0.2);
      }

      .icon {
        font-size: 16px;
      }
    }

    &__form {
      display: flex;
      align-items: center;
    }

    &__input {
      font: inherit;
      border: none;
      background: transparent;
      color: #fff;
    }
  }
}
</style>
